/**
 * Prefills for a student invitation opened from a student record (ADR 0036).
 * Guesses the registrar corrects, never facts the record holds: the record
 * holds one full name, and the invitation wants a given and a family name.
 */

/** A full name as given then family, for prefilling only; the registrar corrects it. */
export function splitFullName(fullName: string | null | undefined): { given: string; family: string } {
  const parts = (fullName ?? "").trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return { given: "", family: "" };
  if (parts.length === 1) return { given: parts[0], family: "" };
  return { given: parts.slice(0, -1).join(" "), family: parts[parts.length - 1] };
}

/** `given.family` in the managed account's local-part alphabet, for the registrar to adjust. */
export function accountNameFor(given: string, family: string): string {
  const slug = (value: string) => value.toLowerCase().normalize("NFKD").replace(/[^a-z0-9]+/g, "");
  const parts = [slug(given), slug(family)].filter(Boolean);
  return parts.join(".");
}

/**
 * Everything a student invitation prefills from the record's one full name:
 * the split and the proposed managed account name. One rule for the single
 * invitation and the roster invitation, so the same student is proposed the
 * same address from either.
 */
export function invitationPrefill(fullName: string | null | undefined): {
  given: string;
  family: string;
  accountName: string;
} {
  const { given, family } = splitFullName(fullName);
  return { given, family, accountName: accountNameFor(given, family) };
}
